import React from "react";
import { showDialog } from "@SeemplicityDev/shared";

interface PopupErrorFallbackProps {
  error: { message: string };
  onRetry: () => void;
  onHomepage: () => void;
}

const PopupErrorFallback: React.FC<PopupErrorFallbackProps> = ({
  error,
  onRetry,
  onHomepage,
}) => {
  const dialogProps = {
    type: "error" as const,
    message: error.message,
    buttons: [
      {
        label: "Back to Homepage",
        onClick: onHomepage,
      },
      {
        buttonStyle: "primary" as const,
        label: "Try Again",
        onClick: onRetry,
      },
    ],
    showCloseIcon: false,
  };

  // showDialog imperatively renders a dialog and returns void; the original JS
  // placed the call as a JSX child (rendering nothing). Call it before
  // returning instead — rolldown's parser rejects the comma operator in JSX.
  showDialog({ ...dialogProps });

  return <div className={"static-fallback-container"} />;
};

export default PopupErrorFallback;
